<template>
  <div>
    <hr class="my-4" v-if="hr && showFacebook">
    <div class="mb-3" v-if="showFacebook">
      <fb-signin-button
          :params="fbSignInParams"
          @success="onSignInSuccess"
          @error="onSignInError">
        <i class="fa fa-facebook mr-3"></i>
        <span v-show="load"><i class="fa fa-spinner fa-pulse"></i> Aguarde</span>
        <span v-show="!load">{{str}}</span>
      </fb-signin-button>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['str', 'hr'],
    name: "LoginFacebook",
    data () {
      return {
        showFacebook: true,
        load: false,
        url: '',
        fbSignInParams: {
          scope: 'email,public_profile',
          return_scopes: true
        }
      }
    },

    methods: {
      logarUsuario(data) {
        if (data.email && data.name && data.id) {
          this.load = true;
          const url = this.origin === '2' ? 'cliente' : this.empresa.token;

          this.$http.post(url + '/login-facebook', data)
            .then(data => {
              this.load = false;

              if (data && data.data.success) {
                this.registerLogin(data);
              }

            }, res => {
              this.load = false;
              console.log(res);
              let msg = res.data && res.data.msg ? res.data.msg : 'Erro temporário';
              this.$swal(msg);
            });

        } else {
          this.$swal("Para logar com o Facebook você deve permitir os dados do perfil e email");
        }
      },

      registerLogin(data) {
        if (data && data.data.success) {
          const user = data.data.dados;
          this.$store.commit('setDataUser', data.data);
          sessionStorage.removeItem('cuponsReadonly');

          if (this.unidades.length) {
            this.unidades.forEach((u) => {
              this.$socket.emit('delivery_connected', user.id_cliente + u.token);
            });

          } else {
            const empresaToken = this.origin === '2' ? "lecard_app_geral" : this.empresa.token;
            this.$socket.emit('delivery_connected', user.id_cliente + empresaToken);
          }

          this.setOneSignal(user, data.data.token);

          if (this.sacola && this.sacola.produtos.length) {
            if (this.origin === '2' && this.empresa.dominio_delivery) {
              this.url = '/empresa/' + this.empresa.dominio_delivery;
            }

            this.$router.push(this.url + '/finalizar');

          } else if (this.$route.name !== 'Perfil') {
            this.$router.push(this.url + '/perfil');
          }

          this.setSentry({ email: user.email });
        }
      },

      setOneSignal(user, token) {
        if (this.oneSignalIntegration) {
          this.$OneSignal.isPushNotificationsEnabled().then(isEnabled => {
            if (isEnabled) {
              this.$OneSignal.setExternalUserId(user.id_cliente).then(res => {
                this.$http.post(this.empresa.token + '/' + token + '/cliente/onesignal', { push_habilitado: '1' }).then(res => {});
              });
            }
          });
        }
      },

      onSignInSuccess() {
        FB.api('/me', {fields: 'email, name'}, data => {
          this.logarUsuario(data)
        })
      },

      onSignInError() {
        this.$swal("Erro ao logar com o Facebook, tente outra forma.");
      },

      isAppStore() {
        const ck = document.cookie.match(RegExp('(?:^|;\\s*)' + 'app-platform' + '=([^;]*)'));
        return ck && ck[1] === 'iOS App Store';
      }
    },

    computed: {
      unidades() {
        return this.$store.state.unidades;
      },

      sacola() {
        return this.$store.state.sacola;
      },

      empresa() {
        return this.$store.state.empresa;
      }
    },

    mounted() {
      this.url = this.origin === '5' ? '/' + this.$store.state.empresa.dominio_delivery : '';
      this.showFacebook = !navigator.userAgent.includes("Instagram") && !this.isAppStore()
          && (this.origin === '5' || (this.empresa.integracoes || []).includes('8'));
    },

    created() {
      this.$parent.$on('registrarLogin', (res) => {
        this.registerLogin(res);
      });
    }
  }
</script>

<style scoped>
  .fb-signin-button {
    cursor: pointer;
    text-align: center;
    padding: 8px 0;
    border-radius: 12px;
    background-color: #4267b2;
    color: #fff;
  }
</style>
